exports.config = {
    defaults: {
        __template: undefined,
        __image: 'https://www.tinaba.bancaprofilo.it/pj/p/img/social_square.jpg',

        __metaTags: {
            title: 'Tinaba presale',
            description: "",
            theme_color: '#FF5E00',

            og: {
                type: 'website',
                url: undefined,
                title: undefined,
                description: undefined,
                image: undefined,
            },

            twitter: {
                card: undefined,
                url: undefined,
                title: undefined,
                description: undefined,
                image: undefined,
            },

            msapplication: {
                tileColor: undefined,
                tileImage: undefined,
            },
        },
        __ctaPosition: 2
    },
    projects: [
        {
            __template: 'premium',

            id: {
                valid: 6,
                prod: 6
            },
            __influencerName: "Premium",
            __influencerCode: "premium",
            __metaTags: {
                theme_color: '#FF5E00',
                title: "Tinaba Premium: Prodotti Esclusivi e Promo dedicate",
                description: "Scopri tutti i vantaggi e le promozioni dedicate alla membership esclusiva Tinaba Premium. Attivala ora!",
                og: {
                    description:"Tinaba Premium: Prodotti Esclusivi e Promo dedicate",
                    image: "hero_desktop_premium.jpg",
                }
            },
            __ctaPosition: 1
        },        
        {
            id: {
                valid: 1,
                prod: 1
            },
            __influencerName: "Elisa Maino",
            __influencerCode: "elisa_maino",
            __influencerShortName: "Elisa",
            __metaTags: {
                theme_color: '#FF5E00',
                title: "Carta Hit di Elisa Maino",
                description: "La Hit di Elisa Maino è arrivata! Fai subito il preordine!",
                og: {
                    description:"Carta Hit di Elisa Maino",
                    image: "ogimage_elisa_maino.jpg",
                }
            },
            __designCarta: {
                text: 'Ciao, sono <span class="font-bd">Elisa Maino</span> e se sei arrivato fin qui è per scoprire tutto sul mio nuovo progetto speciale!<br />Sei pronto a salire a bordo e vivere un’esperienza unica?<br />Preordina subito la mia <span class="font-bd">Carta Hit!</span><br />Il design l\'ho scelto io assieme al famoso designer <span class="font-bd">Nicolò Beretta!</span><br />E’ pensato per voi, la mia community: la rosa è il nostro simbolo, perfetto per un progetto esclusivo come questo.<br /><br />Cosa aspetti? E\' semplicissimo!<br />Preordina la mia carta Hit al costo di 19,99€ e preparati a entrare nel mio mondo.',
            },
            __youtubeVideo: 'https://www.youtube.com/embed/SLnYT3wtgdg',
            __ctaPosition: 1
        },
        {
            id: {
                valid: 2,
                prod: 2
            },
            __influencerName: "Marta Losito",
            __influencerCode: "marta_losito",
            __influencerShortName: "Marta",
            __metaTags: {
                theme_color: '#FF5E00',
                title: "Conto Tinaba Hit di Marta Losito: vantaggi e offerte speciali!",
                description: "Entra a far parte della community di Marta Losito in modo ancora più esclusivo attraverso il suo Profilo Tinaba Hit. Scarica l'App e registrati subito",
                og: {
                    description:"Conto Tinaba Hit di Marta Losito: vantaggi e offerte speciali!",
                    image: "ogimage_marta_losito.jpg",
                }                
            },
            __designCarta: {
                text: 'Ciao amori. Sono <span class="font-bd">Marta Losito</span> e sono qui per parlarvi del nuovissimo progetto a cui ho preso parte.<br />Pronti per entrare a far parte di un club esclusivo? Per farlo preordina la mia <span class="font-bd">Carta Hit</span>.<br />Grazie a <span class="font-bd">Nicolò Beretta</span>, il design della carta è stato pensato ad hoc apposta per voi, per la mia community.<br />I pianeti sono ciò che più ci rappresenta: un universo di emozioni che saranno ancora più nostre.<br /><br />Cosa aspetti? Preordina la mia carta Hit al costo di 19,99€ e preparati a entrare nel mio mondo.',
            },
            __youtubeVideo: 'https://www.youtube.com/embed/woz7gkrInVE',
            __ctaPosition: 2
        },       
        {
            id: {
                valid: 3,
                prod: 3
            },
            __influencerName: "Valerio Mazzei",
            __influencerCode: "valerio_mazzei",
            __influencerShortName: "Valerio",
            __metaTags: {
                theme_color: '#FF5E00',
                title: "Conto Tinaba Hit di Valerio Mazzei: vantaggi e offerte speciali!",
                description: "Diventa parte della community esclusiva del Profilo Tinaba Hit di Valerio Mazzei ed entra nel suo mondo unico ricco di vantaggi. Scarica l'App e registrati subito",
                og: {
                    description:"Conto Tinaba Hit di Valerio Mazzei: vantaggi e offerte speciali!",
                    image: "ogimage_valerio_mazzei.jpg",
                }                   
            },
            __designCarta: {
                titleColor:'#FFFFFF',
                textColor:'#FFFFFF',
                useTurnWhite: true,
                text: 'Ciao a tutti regà, sono <span class="font-bd">Valerio Mazzei</span> e sono qui per presentarvi il mio progetto speciale: la mia <span class="font-bd">Carta Hit</span>... perché è ‘na Hit.<br />Offerte, sconti, pass… tantissimi vantaggi su tutto ciò che appartiene al mio mondo e alle mie passioni e che ora potranno essere ancora più vicine a voi.<br />Grazie al designer <span class="font-bd">Nicolò Beretta</span> ho potuto rendere la carta ancora più mia, fattore essenziale per un progetto esclusivo come questo.<br /><br />Che aspettate? Preordinate la mia carta Hit al costo di 19,99€ e preparatevi a entrare nel mio mondo.',
            },
            __youtubeVideo: 'https://www.youtube.com/embed/woz7gkrInVE',
            __ctaPosition: 2
        },    
        {
            id: {
                valid: 4,
                prod:4
            },
            __influencerName: "SighTanc",
            __influencerCode: "sightanc",
            __influencerShortName: "SighTanc",
            __metaTags: {
                theme_color: '#FF5E00',
                title: "Conto Tinaba Hit di SighTanc: vantaggi e offerte speciali!",
                description: "Preordina ora il Conto Tinaba Hit di SighTanc per avere vantaggi esclusivi come prevendite e eventi speciali. Scarica l'App e registrati subito",
                og: {
                    description:"Conto Tinaba Hit di SighTanc: vantaggi e offerte speciali!",
                    image: "ogimage_sightanc.jpg",
                }                   
            },
            __designCarta: {
                text: 'Bella regà. <span class="font-bd">SighTanc</span>. Pronti per conoscere il progetto più ciotto che ci sia? Si tratta della mia nuova <span class="font-bd">Carta Hit</span>: vantaggi, offerte, pass a Meet & Greet e tanto altro. Cosa aspettate a preordinarla? Per voi la possibilità di entrare in un club esclusivo.<br />Grazie a <span class="font-bd">Nicolò Beretta</span> ho anche potuto inserire un mio disegno sulla mia Carta Hit: ne vado super fiero.<br />Tutto pensato al meglio per un super progetto come questo.<br /><br />Cosa aspettate? Preordinate subito la mia carta Hit al costo di 19,99€ e preparatevi a entrare nel mio mondo.',
            },
            __youtubeVideo: 'https://www.youtube.com/embed/woz7gkrInVE',
            __ctaPosition: 2
        },      
        {
            id: {
                valid: 5,
                prod:5
            },
            __influencerName: "Gordon",
            __influencerCode: "gordon",
            __influencerShortName: "Gordon",
            __metaTags: {
                theme_color: '#FF5E00',
                title: "Conto Tinaba Hit di Gordon: vantaggi e offerte speciali!",
                description: "GRL PWR: questa è la parola d'ordine per entrare a far parte della community esclusiva di Gordon tramite il suo Profilo Tinaba Hit. Scarica l'App e registrati subito",
                og: {
                    description:"Conto Tinaba Hit di Gordon: vantaggi e offerte speciali!",
                    image: "ogimage_gordon.jpg",
                }                   
            },
            __designCarta: {
                text: 'Ehilà belle. Qui <span class="font-bd">zia Gordon</span> che vi parla. Una sigla, sei lettere: GRL PWR. Questa è la parola d’ordine per entrare a far parte della community più esclusiva di sempre tramite la mia <span class="font-bd">Carta Hit</span>. Sconti, offerte, prevendite, pass esclusivi a meet & greet, tutto su prodotti speciali scelti da me per le mie sottone del cuore.<br /><br />Cosa aspettate? Fidatevi di zia Gordon. Vi ho mai deluse? Io non credo.<br /><br />Preordinate subito la mia carta Hit al costo di 19,99€ e preparatevi a entrare nel mio mondo.',
            },
            __youtubeVideo: 'https://www.youtube.com/embed/woz7gkrInVE',
            __ctaPosition: 2
        },      
        {
            __template: 'empty',

            id: {
                valid: 7,
                prod:7
            },
            __influencerName: "LaVerità",
            __influencerCode: "laverita",
            __influencerShortName: "LaVerità",
            __metaTags: {
                theme_color: '#FF5E00',
                title: "LaVerità: vantaggi e offerte speciali!",
                description: "LaVerità: vantaggi e offerte speciali!",
                og: {
                    description:"LaVerità: vantaggi e offerte speciali!",
                    image: "ogimage_gordon.jpg",
                }                   
            },
            __designCarta: {
                text: 'LaVerità: vantaggi e offerte speciali!',
            },
            __youtubeVideo: 'https://www.youtube.com/embed/woz7gkrInVE',
            __ctaPosition: 2
        },                     
    ]
}